<template>
  <div class="secondary d-flex flex-column">
    <h1 class="white--text font-weight-bold text-h5 px-2 mb-4">
      {{ $t("menu.home") }}
    </h1>

    <!-- <span class="caption white--text px-2 mb-4">
      {{ $t("login.title") }}
    </span> -->
    <v-carousel
      v-model="carousel"
      hide-delimiters
      :show-arrows="false"
      height="auto"
      :continuous="true"
      :cycle="true"
      interval="4000"
    >
      <v-carousel-item v-for="(image, i) in images" :key="image + i">
        <v-img :aspect-ratio="1" :src="image.path"></v-img>
      </v-carousel-item>
    </v-carousel>
    <div class="white--text body-2 mb-4 px-4 mt-4">
      {{ $t("home.welcome_description") }}
    </div>

    <div
      class="d-flex align-center justify-center"
      style="gap: 10px; width: 100%"
    >
      <div
        v-for="(item, i) in menu"
        :key="i"
        cols="4"
        class="d-flex flex-column"
        @click="$router.push(item.path)"
      >
        <div
          class="d-flex flex-column align-center justify-center rounded-lg"
          style="
            height: 100px;
            width: 120px;
            background: rgba(255, 255, 255, 0.2);
          "
        >
          <v-icon color="white" size="40"> {{ item.icon }}</v-icon>
          <span class="white--text body-2 text-center">
            {{ item.label }}
          </span>
        </div>
      </div>
    </div>

    <div class="white--text body-2 px-4 mt-6 d-flex justify-center">
      {{ $t("home.welcome_outro") }}
    </div>

    <div class="d-flex justify-center mt-8">
      <img
        src="@/assets/pedin-logo.png"
        width="200px"
        height="auto"
        class="mr-4"
      />
    </div>

    <div class="d-flex justify-center mt-8 pb-4">
      <img src="@/assets/espa.png" width="95%" height="auto" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      carousel: 0,
    };
  },

  computed: {
    images() {
      return [
        {
          path: require("@/assets/island-images/1.Κέρκυρα-min.jpg"),
        },
        {
          path: require("@/assets/island-images/2.Παξοί-min.jpg"),
        },
        {
          path: require("@/assets/island-images/3.Λευκάδα-min.jpg"),
        },
        {
          path: require("@/assets/island-images/4.Μεγανήσι-min.jpg"),
        },
        {
          path: require("@/assets/island-images/5.Κεφαλονιά-min.jpg"),
        },
        {
          path: require("@/assets/island-images/6.Ιθάκη-min.jpg"),
        },
        {
          path: require("@/assets/island-images/7.Ζάκυνθος-min.jpg"),
        },
      ];
    },
    menu() {
      return [
        {
          label: this.$t("menu.islands"),
          icon: "mdi-island",
          path: "/islands",
        },

        {
          label: this.$t("menu.pois"),
          icon: "mdi-map-marker-multiple",
          path: "/pois",
        },

        {
          label: this.$t("menu.routes"),
          icon: "mdi-map-marker-path",
          path: "/routes",
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss"></style>
